"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NE = exports.LT = exports.LIKE = exports.LE = exports.GT = exports.GE = exports.EQ = void 0;
var LIKE = 'LIKE';
exports.LIKE = LIKE;
var EQ = '=';
exports.EQ = EQ;
var NE = '!=';
exports.NE = NE;
var GT = '>';
exports.GT = GT;
var GE = '>=';
exports.GE = GE;
var LT = '<';
exports.LT = LT;
var LE = '<=';
exports.LE = LE;